import { enums } from '@kattana-io/common';
import Text from '../../../atoms/Text';
import { ICurrentState } from '../../../reducers/current';
import { IPoolWidgetNews, IPoolWidgetScore } from '../useTickerPool';
import { PoolWidgetTab } from '..';

import './styles.scss';

const getPoolTabs = (
  current: ICurrentState,
  news?: IPoolWidgetNews | null,
  score?: IPoolWidgetScore | null
) => {
  const tabs =
    current.kind === enums.ETickerKind.CEX
      ? [PoolWidgetTab.info]
      : [PoolWidgetTab.info, PoolWidgetTab.liquidity];
  // if (news) {
  //   tabs.push(PoolWidgetTab.news);
  // }
  if (score) {
    tabs.push(PoolWidgetTab.score);
  }
  return tabs;
};

const getScoreClassName = (points?: number) => {
  if (points !== undefined) {
    if (points < 5) {
      return 'pool_tabs__item--red';
    }
    if (points >= 7) {
      return 'pool_tabs__item--green';
    }
  }
  return '';
};

interface IPoolTabsProps {
  activeTab: PoolWidgetTab;
  setTab(tab: PoolWidgetTab): void;
  current: ICurrentState;
  news?: IPoolWidgetNews | null;
  score?: IPoolWidgetScore | null;
}

const PoolTabs = ({
  activeTab,
  setTab,
  current,
  news,
  score,
}: IPoolTabsProps) => {
  const tabs = getPoolTabs(current, news, score);

  return (
    <div className='pool_tabs'>
      {tabs.map((tab) => (
        <div
          key={tab}
          className={`pool_tabs__item ${
            tab === activeTab ? 'pool_tabs__item--active' : ''
          } ${
            tab === PoolWidgetTab.score ? getScoreClassName(score?.points) : ''
          }`}
          onClick={() => setTab(tab)}
        >
          <Text size={12}>{tab}</Text>
          {tab === PoolWidgetTab.score && (
            <Text size={10} className='pool_tabs__item__count'>
              {score?.points}
            </Text>
          )}
        </div>
      ))}
    </div>
  );
};

export default PoolTabs;
